module.exports = __webpack_public_path__ + "img/茵陈.94773ab2.jpg";